import React, { Component } from 'react';
import './InputField.css';
import classnames from 'classnames'
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
class InputField extends Component {
    render() {
        const { id, disabled, labelName, translate, placeholder, dependenceValidation, input, uppercase, meta: { touched, error, warning } } = this.props;
        return (
            <div>
                <div className="input-group">
                    <input
                        disabled={disabled || dependenceValidation}
                        className={classnames('input-field', { 'Uppercase': uppercase }, { 'suc-text': touched }, { 'view-text': disabled })}
                        id={id}
                        placeholder={placeholder} {...input}
                        value={input.value}
                        autoComplete="off" />
                    <label className={classnames('input-label',
                        //{'enter-text-label' :error && touched,'input-label-error': error && touched},
                        {
                            'suc-label': touched
                            //!error && input.value.length > 0
                        },
                        { 'view-label': disabled })}
                        htmlFor={id} >{translate(labelName)}</label>
                </div>
                {touched && (error && <span className="error-text">{translate(error)}</span>)}
            </div>
        )
    }
}
const mapStateToProps = state => ({
    translate: getTranslate(state.locale),
});
export default connect(mapStateToProps)(InputField)





// WEBPACK FOOTER //
// ./src/components/Input-field/InputField.js